import { FC } from 'react';

import CertificationViewHeader from './CertificationViewHeader';
import CertificationViewBody from './CertificationViewBody';

const CertificationView: FC = () => (
  <div className="nk-ibx-reply-item nk-reply-item">
    <CertificationViewHeader />

    <CertificationViewBody />
  </div>
);

export default CertificationView;
